import { Component, HostBinding, OnInit, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UtilityService } from '../../../../services';
import { CommonFieldWidgetBase } from '../common-field-widget-base';
import { CommonTextField } from '../field';
import { getLabels } from '../field.labels';


@Component({
	selector: 'common-text-field',
	imports: [FormsModule],
	templateUrl: './common-text-field.widget.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	host: {	'[class.d-none]': 'isExcluded()' },

})
export class CommonTextFieldWidget extends CommonFieldWidgetBase<string, CommonTextField> implements OnInit {

	private util = inject(UtilityService);

	public readonly field = input.required<CommonTextField>();

	private readonly labels = computed(() => {
		const config = this.field().config();

		return {
			...getLabels(config.isSpanish),

			// Set custom min and max length labels based on calculated min and max lengths
			minLength: config.isSpanish ? `Texto muy corto. Mínimo de ${config.min} caracteres.` : `Text too short. Min of ${config.min} characters.`,
			maxLength: config.isSpanish ? `Texto muy largo. Máximo de ${config.max} caracteres.` : `Text too long. Max of ${config.max} characters.`
		}

	});


	public readonly renderedModel = computed(() => {
		const value = this.field().pendingValue() ?? this.field().actualValue();
		if (!this.hasFocus()) return this.render(value);
		return value;
	});


	public readonly almostMaxLength = computed<{ text: string, error: boolean }>(() => {
		const config = this.field().config();
		const value = this.field().pendingValue() ?? this.field().actualValue();

		const calculatedMax = config.max && config.max > 5 ? config.max - 5 : config.max || 0;
		if (config.max && value.length && value.length > calculatedMax) {
			return { text: `${value.length} / ${config.max}`, error: value.length > config.max };
		}
		else return { text: config.multiLine && config.max ? `${value.length} / ${config.max}` : '', error: false };
	});


	ngOnInit() {
		this.onInit(this.field());
	}


	public onChange(value: string) {
		this.processChange(value)
	}


	public async onBlur() {
		await this.processBlur();
	}


	protected override cleanValue(value: string) {
		const method = this.field().config().fixCase;
		return this.util.text.fixCase(value, method);
	}


	protected override render(value: string) {
		const method = this.field().config().fixCase;
		return this.util.text.fixCase(value, method);
	}


	protected validate(value: string): string {

		const config = this.field().config();
		if (value.length == 0 && config.min) return this.labels().missingRequired();
		if (value.length < config.min) return this.labels().minLength;
		if (config.max && value.length > config.max) return this.labels().maxLength;

		return '';
	}


	public setFocus() {
		console.error('setFocus() not implemented');
	}

	
	get isOptional() {
		if (this.field && this.field().config().label && this.field().config().min === 0) {
			return this.labels().optionalWithParentheses();
		}
		return '';
	}
}